const labTestProcessor=(element,idaValues)=>
{
let assembledElement = ""

switch (element["symptom"]) {
    case "Bence–Jones protein urine test suggests myeloma" :
        assembledElement += " a urine test"
        break;

    default:
            assembledElement += " blood tests"
            break;
    }

if (element["Date_of_test"] !== "")
    {
    let testDate = new Date (element["Date_of_test"])
    let testDateString = testDate.toLocaleDateString()
    assembledElement += ` on ${testDateString}`
    }
if (element["Lab_where_test_performed:"] !== "")
    {
     assembledElement += ` at the ${element["Lab_where_test_performed:"]} laboratory`   
    }

if (element["symptom"] === "Bence–Jones protein urine test suggests myeloma" )
    {
    assembledElement += " showing Bence-Jones protein suggestive of myeloma"
    }

else if (element["symptom"] === "PSA above ref for age" )
    {
    assembledElement += " showing a PSA value above the reference range for their age"
    }

else
    {
    assembledElement += ` which showed ${element["symptom"].toLowerCase()}`
    }

if (element["Results_available_electronically_in_GP_record?"] !== "")
    {
    assembledElement += ` (the results of these ${(element["Results_available_electronically_in_GP_record?"] === "Yes" ? "are" : "are not")} in the primary care electronic record)`
    }

if (element["Result(s)_(if_not_available_electronically):"] !== "")
    {
        assembledElement += `. The result was ${element["Result(s)_(if_not_available_electonically):"]}`
    }

if (element["symptom"] === "Iron Deficiency Anaemia")
    {
    assembledElement += `. They ${(idaValues.ironReplacement ? "have" : "have not")} been on iron replacement therapy`
        if (idaValues.riseOnIron !== "" && idaValues.riseOnIron)
            {
            assembledElement +=` and this has resulted in a haemoglobin rise of over 10g/l`
            }

    assembledElement += `. ${(idaValues.ironReplacement ? "Before iron replacement they had" : "They have")}`
    assembledElement += ` a haemoglobin of ${idaValues.Haemoglobin}g/l${idaValues.MCV === "" ? " and " : ", "}a ferritin of ${(idaValues.Ferritin)}ug/l${idaValues.TIBC ==="" && idaValues.MCV !== "" ? " and " : (idaValues.TIBC !== "" && idaValues.MCV !== "" ? ", " : "")}${idaValues.MCV !== "" ? ` an MCV of ${idaValues.MCV}fl` : ""}${idaValues.TIBC ? `, a TIBC of ${idaValues.TIBC}umol/l and an iron saturation of ${idaValues.ironSat}%` : ""}`

    }

if (element["Comments"] !== "")
    {
    assembledElement += `. Comments: ${element["Comments"]}`
    }








return (assembledElement)
}

export default labTestProcessor



